import Navbar from "../components/navbar"
import { useState } from "react"
import { FaBars } from "react-icons/fa"
import { AiFillPhone } from "react-icons/ai"
import { IoMdMail } from "react-icons/io"
import Footer from "../components/footer"

const MyTeamPage = () => {
    const [navShown, setNavShown] = useState("hidden")
    const [showBar, setShowBar] = useState(true)
    const [showXmark, setShowXmark] = useState("hidden")
    const openNav = () => {
        setNavShown("block")
        setShowBar("hidden")
        setShowXmark("inline")
    }
    const closeNav = () => {
        setNavShown("hidden")
        setShowBar("inline")
        setShowXmark("hidden")
    }
    return (
        <Navbar active={"my-team"} navShow={navShown}>
            <div className="flex w-full bg-cyan-900 items-center fixed z-20">
                <FaBars className={`text-[20px] text-white relative left-4 lg:hidden ${showBar}`} onClick={openNav} />
                <span className={`text-[25px] ${showXmark} text-white font-bold relative left-72`} onClick={closeNav}>
                    X
                </span>
                <h1 className="text-center text-white py-4 w-full font-bold">My Team</h1>
            </div>
            <div className="relative top-14 ">
                <div className="flex flex-col gap-x-6 lg:flex-row w-[85%] lg:w-[90%] m-auto justify-between mt-4 pb-24">
                    <div className="lg:w-1/2" >
                        <h1 className="font-semibold">My Team</h1>
                        <div className="p-3 mt-2 ml-1 rounded-lg" style={{ boxShadow: "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px" }}>
                            <span className="font-semibold block">
                                Samuel Vergara
                            </span>
                            <span className="block text-[14px]">
                                Sr. Surgical Services Recruiter
                            </span>
                            <div className="flex flex-col mt-2">
                                <div className="flex items-center gap-x-2">
                                    <AiFillPhone className="text-[20px]" />
                                    <a href="tel:(858)666-6615">(858) 666-6615</a>
                                </div>
                                <div className="flex items-center gap-x-2">
                                    <IoMdMail className="text-[18px]" />
                                    <a href="mailto:Samuel.Vergara@ayahealthcare.com" className="font-semibold text-[14px]">Samuel.Vergara@ayahealthcare.com</a>
                                </div>
                            </div>
                            <div className="flex justify-between items-center">

                            </div>
                        </div>
                    </div>
                    <div className="lg:w-1/2">
                        <div className="px-2 mt-4">
                            <h1 className="font-semibold ">
                                After-hours emergency team
                            </h1>
                            <p className="text-[14px] py-2">
                                If it's after hours and you have an emergency that can't wait (think: my apartment is flooded!) please contact our emergency team.
                            </p>
                        </div>
                        <div style={{ boxShadow: "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px" }} className="px-2 py-1 mt-3 rounded-lg">
                            <h1 className="font-semibold text-[14px] py-2">
                                After-hours emergency team
                            </h1>
                            <p className="text-[14px]">
                                If it's after hours and you have an emergency that can't wait (think: my apartment is flooded!) please contact our emergency team.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="fixed bottom-0 w-full">
                    <Footer />
                </div>
            </div>
        </Navbar>
    )
}

export default MyTeamPage